import React from 'react';
import PropTypes from "prop-types";

const ORIGIN = {
  TOP: "TOP",
  BOTTOM: "BOTTOM"
};

/**
 * ScrollableContainer - Generic component for displaying a list of entities as components
 * Provide your component as a child of the list
 */
export default class ScrollableContainer extends React.Component {
  
  static ORIGIN = ORIGIN;

  static propTypes = {
    className    : PropTypes.string.isRequired,
    origin       : PropTypes.oneOf( Object.keys( ORIGIN )),
    scrollKey    : PropTypes.any
  }

  static defaultProps = {
    scrollKey : null,
    origin: ORIGIN.TOP,
    placeholder: null
  }

  /**
   * ref methods for storing internal elements
   */
  refContainer = (container) => {
    this.container = container;
  }

  /**
   * scroll to the top or bottom of the page, depending on the origin
   */
  scrollToOrigin = () => {
    switch (this.props.origin) {
      case ORIGIN.BOTTOM:
        this.container.scrollTop = this.container.scrollHeight;
        break;
      // default to top-down
      case ORIGIN.TOP:
      default:
        this.container.scrollTop = 0;
        break;
    }
  }
  /**
   * Restore the scroll position from the state
   * If the scroll was at the origin before, then restore it to the new origin
   */
  restoreScrollTop = () => {
    const { scrollWasAtOrigin, storedScrollTop } = this;
    if (scrollWasAtOrigin) {
      this.scrollToOrigin();
    } else {
      this.container.scrollTop = storedScrollTop;
    }
  }
  
  /**
   * Scroll to origin immediately on mount
   */
  componentDidMount() {
    this.scrollToOrigin();
  }
  
  // TODO: use getSnapshotBeforeUpdate instead of UNSAFE_componentWillUpdate
  /**
   * If the component is about to update, stash the scrollTop
   * This isn't being stored in state because it doesn't affect the render
   * Also remember whether the scroll was at the origin
   */
  componentWillUpdate(nextProps, nextState) {
    const { TOP, BOTTOM } = ORIGIN;
    const { origin } = this.props;
    const { scrollTop, scrollHeight, clientHeight } = this.container;
    const maxScrollTop = scrollHeight - clientHeight;
    this.scrollWasAtOrigin = (origin === TOP && scrollTop === 0) || (origin === BOTTOM && scrollTop === maxScrollTop);
    this.storedScrollTop = scrollTop;
  }
  
  /**
   * After a re-render, check whther we should reset or restore scroll position
   */
  componentDidUpdate(prevProps, prevState) {
    // If the domain has changed, reset the scroll
    if (prevProps.scrollKey !== this.props.scrollKey) {
      this.scrollToOrigin();
    // Otherwise, restore the stashed scroll
    } else {
      this.restoreScrollTop();
    }
  }

  render() {
    return (
      <div className={this.props.className} ref={this.refContainer}>
        { this.props.children }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ScrollableContainer.js